export const log = (err) => {
  if (`${process.env.LOG}`) {
    if (err && err.stack && err.message) {
      console.error(err);
    } else {
      console.log(err)
    }
  }
};
